<template>

  <div class="box-product">
    <router-link :to="{name:'ProductDetail', params: {id: product.id, product: product}}">
      <div class="box-image">
        <img :src="product.imageURL_M">
      </div>
    </router-link>
    <div class="box-data">

      <h1 v-html="product.titulo"></h1>

      <div class="precio" v-if="actualStock>0">
        {{product.precio_mayorista | currency }} + IVA
      </div>
      <div class="precio" v-else>
        AGOTADO
      </div>

        <div class="quick-cart" v-if="actualStock>0">
            <select class="" v-model="quantity">
                <option :value="n" v-for="(n,index) in actualStock" :key="index">{{n}} unidades</option>
            </select>
            <a href="#" class="btn-quickadd" @click.prevent="quickAddToCart(product)">
                <span>AGREGAR</span>
            </a>
        </div>

    </div>
  </div>


</template>

<script>
    export default {
        props:['product'],
        data(){
          return {
            quantity:1
          };
        },
        computed:{
          actualStock(){
            return parseInt(this.product.stock_unico)
          }
        },
        methods:{
          quickAddToCart(product){

            this.$store.dispatch('addToCart', {product:product,quantity:this.quantity})
              .then(() => {
                $("nav.micarrito, .overlay-micarrito").addClass("open");
                $("body").addClass("lock");
              })
              .catch(err => {

                this.$swal({
                  title: 'Oops!',
                  text: err,
                  type: 'error',
                }).then((result) => {

                })

              });
          }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductBox.vue